import { MarqueeRow } from '@marketing/components'

interface QuetureThumb {
  url: string
  alt: string
}

interface QuetureMarqueeSectionProps {
  /** Title rows — first 2 white (Regular), last bold + highlighted */
  bodyLine1: string
  bodyLine2: string
  emphasis: string
  row1: QuetureThumb[]
  row2: QuetureThumb[]
}

export function QuetureMarqueeSection({
  bodyLine1,
  bodyLine2,
  emphasis,
  row1,
  row2,
}: QuetureMarqueeSectionProps) {
  return (
    <section id="queture-marquee" data-marketing-section="" className="w-full bg-qb-text-high pt-14 lg:pt-20 pb-14 lg:pb-26 tracking-[-0.6px]">
      {/* Title */}
      <div className="flex flex-col gap-2 items-center text-center mb-10 lg:mb-16 px-6">
        <div className="text-white font-normal text-[24px] lg:text-[28px] leading-[1.4]">
          <p>{bodyLine1}</p>
          <p>{bodyLine2}</p>
        </div>
        <p className="text-qb-primary font-bold text-[28px] lg:text-[32px] leading-[1.4]">
          {emphasis.split('\n').map((line, i, arr) => (
            <span key={i}>
              {line}
              {i < arr.length - 1 && (
                <>
                  <br className="lg:hidden" />
                  <span className="hidden lg:inline"> </span>
                </>
              )}
            </span>
          ))}
        </p>
      </div>

      {/* Two-row marquee */}
      <div className="flex flex-col gap-4">
        <MarqueeRow speed="normal" gap={16}>
          {row1.map((thumb) => (
            <img
              key={thumb.url}
              src={thumb.url}
              alt={thumb.alt}
              className="w-[242px] h-[136px] rounded-[16px] object-cover"
            />
          ))}
        </MarqueeRow>
        <MarqueeRow speed="normal" gap={16} reverse>
          {row2.map((thumb) => (
            <img
              key={thumb.url}
              src={thumb.url}
              alt={thumb.alt}
              className="w-[242px] h-[136px] rounded-[16px] object-cover"
            />
          ))}
        </MarqueeRow>
      </div>
    </section>
  )
}
